
import {
setLStore,
getLStore,
removeLStore,
IsValid,
IsBottom,
getBefore,
getHind,
getSStore,
removeSStore
} from "@js/public/mUtils";
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import { NoScroll, Scroll } from "@js/public/animation";
import Sort from "@/components/publicComponents/sort";
import sLoading from "@/components/publicComponents/sLoading";
import WXConfig from '@/assets/js/wx.jsapi'
export default {
name: "all",
components: {
InlineLoading,
Divider,
XTable,
Tab,
TabItem,
"my-sort": Sort,
"my-sloading": sLoading,
},
props: ["scroll"],
data() {
return {
main: false,
fundTypeTop: false, // 基金分类是否固定在顶部
pageNum: 12, // 每页内容数
canScroll: false, // 能否滚动加载更多
canRun: true, // 节流
scrollLoading: true, // 加载中loading
fundItems: [], // 基金列表
fundtypeItems: {}, // 基金类型列表
fundType: "", // 当前选择的基金类型
fundSort: "", // 基金排序方式
fundTypeNum: 0,
sortShow: {
monthinc: true,
},
sortUp: true,
thead: {
length2: "单位净值",

},
};
},
watch: {
fundType: function (val, oldVal) {
if (val === "0524104039") {
this.thead.length2 = "七日年化";
this.thead.length3 = "万份收益";
} else {
this.thead.length2 = "单位净值";

}
},
},
activated() {
console.log(776654433);
removeSStore('onlyCloneBag')
this.eventBus.$emit("changeTab", 1);
this.WXConfig.wxShowMenu('3')
window.onscroll = this.myScroll;
},
created() {
this.$emit("changeTab", 1);
this.getFundTypeList().then((res) => {

if (IsValid(this.$store.state.fundTypeNum)) {
this.fundTypeNum = this.$store.state.fundTypeNum;
}
this.mainLoaded(this);
});

if (IsValid(this.$store.state.scrollLoading)) {
this.scrollLoading = this.$store.state.scrollLoading;
this.fundType = this.$store.state.fundType;
}
if (this.$store.state.allFundItems.length >= 1) {
this.fundItems = this.$store.state.allFundItems;
if (this.$store.state.scrollLoading) {
this.canScroll = true;
}
window.onscroll = this.myScroll;
} else {
this.getFunds(1, this.pageNum, "").then((res) => {
window.onscroll = this.myScroll;
});
}
},
mounted() {

this.delay = this.throttle(function () {
console.log("滚动");
if (IsBottom()) {
if (this.canScroll && this.scrollLoading) {

this.canScroll = false;
setTimeout(() => {
this.getFunds(
parseInt(this.fundItems.length / this.pageNum) + 1,
this.pageNum,
this.fundType,
this.fundSort
).then((res) => {});
}, 10);
}
}
}, 300);
},
methods: {
/*初始化scroll事件*/
initScroll() {
window.onscroll = this.myScroll;
},

getFundTypeName(type) {
const _this = this;
for (var key in this.fundtypeItems) {
if (key == type) {
return _this.fundtypeItems[key];
}
}
},

getFundTypeList() {
return this.$http.post("/dict/fundType", {}).then((res) => {
for(var v in res.body.dict){
if(!res.body.dict) return
if (typeof( res.body.dict[v]) === 'undefined' || res.body.dict[v] === null) {
delete res.body.dict[v]
}
}
this.$store.state.fundTypeList = res.body.types;
this.fundtypeItems = res.body.dict;
});
},

getDayinc(val) {
return (val * 100).toFixed(2);
},

getFunds(index, length, type, sort) {
return this.$http
.post("/fund/list/page", {
pageIndex: index,
pageLength: length,
fundType: type,
sortType: sort,
})
.then((res) => {
for (var i = 0; i < res.body.list.length; i++) {
res.body.list[i].interested = false;
}
this.fundItems = this.fundItems.concat(res.body.list);
this.$store.state.allFundItems = this.fundItems;
this.$store.state.fundType = this.fundType;
return res;
})
.then((res) => {

if (res.body.list.length + 1 < this.pageNum) {
this.scrollLoading = false;
this.$store.state.scrollLoading = false;
this.canScroll = false;
} else {
this.canScroll = true;
this.$store.state.scrollLoading = true;
}
return res;
});
},

myScroll() {
const _this = this;
this.delay();
},
delay() {},

throttle(fn, interval = 300) {
let canRun = true;
return function () {
if (!canRun) return;
canRun = false;
setTimeout(() => {
fn.apply(this, arguments);
canRun = true;
}, interval);
};
},
/*跳转基金详情*/
toProduct(code) {

if (code === "001909") {
this.toPage('/changeBag', {})

} else {
this.toPage("/productDetail", { fundCode: code });
}
},

onItemClick(type, item = '', index = '') {
console.log(type);

this.sa.track('fund_page_button_click', {
first_module: '理财',
second_module: '基金分类',
third_module: '基金分类',
button_name: item,
module_sort: index,
content_id: type,
content_name: item,
})

this.initSortIcon();
this.fundType = type;
this.fundItems = [];
this.scrollLoading = true;
this.$store.state.fundTypeNum = this.fundTypeNum;
this.getFunds(1, 12, this.fundType).then((res) => {
this.fundItems = res.body.list;
});
},
/**
* [fundSort 基金排序]
* @param  {[type]} sort [排序列名称]
* @return {[type]}      [description]
*/
sort(sort) {
const button_name = (sort.name === 'monthinc') ? '近1月涨幅' : '单位净值';

this.sa.track('fund_page_button_click', {
first_module: '理财',
second_module: '筛选方式',
third_module: '筛选方式',
button_name: button_name,
module_sort: (sort.name === 'monthinc') ? '1' : '2',
content_id: sort.name,
content_name: button_name,
})

console.log('用户点击升降排序sort==>', sort, '--- ', this.fundType, '--- ', sort.name);

this.initSortIcon(sort.name);
this.fundSort = sort.name;
this.fundItems = [];
this.scrollLoading = true;
if (sort.flag) {
this.getFunds(1, 12, this.fundType, sort.name);
} else {
this.getFunds(1, 12, this.fundType);
}
},
/**
* [initSortIcon 初始化排序图标]
* @param  {[type]} line [不初始化的列名称]
* @return {[type]}      [description]
*/
initSortIcon(line) {
for (var key in this.$refs) {
if (key != line) {
this.$refs[key].init();
} else {
}
}
},
},
};



// WEBPACK FOOTER //
// ./src/components/home/money/all.vue